import { text } from './text';

export const assertNever = (val: never): never => {
    throw new Error(`${text.unexpected}${String(val)}`);
};
